export class GeopostThreeJsConstants {
    public static yDivisionFactor = 1000;
    public static xDivisionFactor = 100;
    public static pictureTextureHeight = 968;
    public static pictureTextureWidth = 1920;
    public static coordinateDivisionFactor = 30000;
}